import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        gap: theme.spacing(1),
        "@media (min-width: 1600px)": {
            gap: theme.spacing(2),
        },
        width: "20%",
        justifyContent: "center",
    },
    dataContainer: {
        marginTop: 10,
        display: "flex",
        flexDirection: "column",
        width: "95%",
        height: "90%",
        overflowY: "auto",
    },
    failureTypeContainer: {
        display: "flex",
        gap: theme.spacing(1),
        marginRight: 15,
        marginBottom: 5,
        alignItems: "center",
    },
    icon: {
        width: "14px !important",
        height: "14px !important",
    },
    title: {
        fontSize: "12px !important",
        whiteSpace: "nowrap",
    },
}));
